const AllLoans = () => import("./views/AllLoans.vue");
const LoanRequestForm = () => import("./views/LoanRequestForm.vue");
const AllLoanApproval = () => import("./views/AllLoanApproval.vue");
export default [
  {
    path: "",
    redirect: "/ess/payroll/loan/view-all",
  },
  {
    name: "view-my-loans",
    path: "view-all",
    component: AllLoans,
  },
  {
    name: "create-my-loan",
    path: "create",
    component: LoanRequestForm,
  },
  {
    name: "edit-my-loan",
    path: "edit/:id",
    component: LoanRequestForm,
  },
  {
    name: "view-my-approvals",
    path: "approval/view-all",
    component: AllLoanApproval,
  },
];
